import {
	Button,
	Card,
	CircularProgress,
	FormControl,
	FormControlLabel,
	IconButton,
	InputAdornment,
	Radio,
	RadioGroup,
	TextField,
	Typography,
} from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DownArrow from '@material-ui/icons/ArrowDropDown';
import UpArrow from '@material-ui/icons/ArrowDropUp';
import Refresh from '@material-ui/icons/Refresh';
import { EarningObject } from '../../../Stock/EarningObject';
import { ExDiveObject } from '../../../Stock/ExDiveObject';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from '../../../../actions/types';
import SharkIcon from '../../../icons/shark.png';

import { firestore } from '../../../../fire';
import { useParams } from 'react-router-dom';

const TopBarWebView = ({
	styles,
	lengthCheck,
	changeTicker,
	keyPress,
	refreshOpenInterest,
	handleType,
	openChart,
	refreshDataAndExpirations,
	targetFromChange,
	targetToChange,
	handlePercent,
}) => {
	let { ticker } = useParams();
	const state = useSelector((state) => state.OpenInterestState);
	const appReducer = useSelector((state) => state.appReducer);
	const { quoteInfo } = appReducer;
	const { change, changePercent } = quoteInfo;
	const priceChange = change;
	const priceChangePercent = changePercent;

	const dispatch = useDispatch();

	const setStateAction = (newState) => {
		dispatch({
			type: ActionTypes.SET_OPEN_INTREST,
			payload: newState,
		});
	};

	const [earningToolTip, setEarningToolTip] = useState('');
	const [exToolTip, setexToolTip] = useState('');

	const getSmallest = (filteredExdiv) => {
		const now = moment(); // Current time
		const mappedDates = filteredExdiv.map((element) => {
			const date = moment(element.date);
			const difference = date.diff(now); // Difference in milliseconds
			return { ...element, difference }; // Adding difference to the element
		});
		// Sort the mapped dates based on difference in ascending order
		return mappedDates.sort((a, b) => a.difference - b.difference);
	};

	const [tickerState, setTickerState] = useState();

	const fetchEarningDate = async () => {
		setEarningToolTip('');
		setexToolTip('');
		try {
			if (Object.values(quoteInfo).length > 0) {
				// Corrected condition
				const checkTicker = tickerState
					? tickerState.toUpperCase()
					: quoteInfo.symbol.replace('/', '-');

				const earningDoc = await firestore
					.collection('calendars')
					.doc(checkTicker)
					.get();
				const data = earningDoc.data();

				const filteredEarning = Object.values(data).filter(
					(obj) => obj.type === 'Earnings'
				);

				const filteredExdiv = Object.values(data).filter(
					(obj) => obj.type === 'ExDiv'
				);

				if (filteredEarning.length > 0) {
					const smallestEarning = getSmallest(filteredEarning);
					setEarningToolTip('Earnings: ' + smallestEarning[0].date);
				}

				if (filteredExdiv.length > 0) {
					const smallestExdiv = getSmallest(filteredExdiv);
					setexToolTip('Dividend: ' + smallestExdiv[0].date);
				}
			}
		} catch (error) {
			console.log(error);
		}
	};
	useEffect(() => {
		fetchEarningDate();
	}, [ticker]);

	return (
		<div style={styles.headerfilterdiv}>
			<Card style={styles.selectors}>
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
					}}
				>
					<div style={styles.tickerContainer}>
						<input
							name='ticker'
							style={styles.tickerInput}
							value={appReducer.ticker}
							placeholder='Stock Ticker'
							onChange={(event) => {
								setTickerState(event.target.value);
								changeTicker(event);
							}}
							onKeyDown={(event) => keyPress(event)}
						/>
						<Link to={`/openinterest/${appReducer.ticker}`}>
							<Button
								id='btnGO'
								variant='contained'
								style={styles.goButton}
								onClick={async () => {
									setStateAction({
										localTicker: appReducer.ticker,
										from: '-',
										to: '-',
										fromValue: 0,
										toValue: 99999999,
										percent: null,
										putsLimit: 99999999,
										callsLimit: 99999999,
										dates: [],
										showChart: false,
										putsChartData: [],
										callsChartData: [],
										modalStrikes: [],
										step: 1,
										max: 1,
									});
									await refreshOpenInterest(appReducer.ticker);
									window.scroll(0, 0);
									fetchEarningDate();
								}}
							>
								Go
							</Button>
						</Link>
					</div>

					<div style={{ marginLeft: '-15px' }}>
						<Button
							style={
								state.type === 'calls' ? styles.callbtn : styles.callbtndisable
							}
							onClick={() => handleType()}
						>
							Calls
						</Button>
						<Button
							onClick={() => handleType()}
							style={
								state.type === 'puts' ? styles.putbtn : styles.putbtndisable
							}
						>
							Puts
						</Button>
						{state.dates.length > 0 && (
							<Button onClick={() => openChart()} style={styles.btnchart}>
								Chart
							</Button>
						)}
					</div>
				</div>
			</Card>
			<Card style={{ ...styles.selectors, width: '20%' }}>
				{ticker && (
					<Typography
						variant='inherit'
						component='h3'
						style={styles.companyText}
					>
						{/* {appReducer.quoteInfo.companyName && !appReducer.isMobile
							? appReducer.quoteInfo.companyName.substring(0, 12)
							: ''}{' '} */}
						{!appReducer.isMobile
							? `${ticker} `
							: `${ticker} $${(
									appReducer.quoteInfo.latestPrice * 1
							  ).toFixed(2)}
              `}
					</Typography>
				)}
				{!ticker && (
					<Typography
						variant='inherit'
						component='h3'
						style={styles.noTickerText}
					>
						Enter a stock ticker to your left & click 'Go'
					</Typography>
				)}
				{ticker && (
					<div style={styles.stockPriceInfo}>
						{!appReducer.isMobile && (
							<span
								style={
									appReducer.isMobile
										? styles.stockPriceMobile
										: styles.stockPrice
								}
							>
								${(appReducer.quoteInfo.latestPrice * 1).toFixed(2)}
							</span>
						)}
						<span
							style={
								priceChange < 0 ? styles.negPriceChange : styles.posPriceChange
							}
						>
							{priceChange < 0 ? (
								<DownArrow
									style={
										appReducer.isMobile
											? styles.downArrowMobile
											: styles.downArrow
									}
								/>
							) : (
								<UpArrow
									style={
										appReducer.isMobile ? styles.upArrowMobile : styles.upArrow
									}
								/>
							)}{' '}
							<span style={styles.priceChange}>
								${Math.abs(priceChange).toFixed(2)}
							</span>
							({Math.abs(priceChangePercent).toFixed(2)}
							%)
						</span>

						{appReducer.refreshingQuote || appReducer.refreshingData ? (
							<CircularProgress
								style={styles.circularSpinner}
								size={24}
								color='primary'
							/>
						) : (
							<IconButton
								aria-label='Refresh'
								disabled={
									appReducer.refreshingQuote || appReducer.refreshingData
								}
								size='small'
								color='primary'
								style={styles.refreshButton}
								onClick={() => {
									refreshDataAndExpirations(appReducer.ticker);
								}}
							>
								<Refresh />
							</IconButton>
						)}
					</div>
				)}
				{state.localTicker && (
					<div style={{ display: 'flex' }}>
						<Typography
							variant='body1'
							component='div'
							style={styles.timestampText}
						>
							As of{' '}
							{moment(appReducer.quoteInfo.latestUpdate).format('MMM DD h:mma')}
						</Typography>
						<div style={{ display: 'flex' }}>
							{earningToolTip ? (
								<EarningObject earningToolTip={earningToolTip} />
							) : null}
							{exToolTip ? <ExDiveObject exToolTip={exToolTip} /> : null}
						</div>

						{lengthCheck ? (
							<div
								style={{
									height: '20px',
									width: '20px',
									marginLeft: '10px',
								}}
								onClick={() => setStateAction({ holderModal: true })}
							>
								<img height='100%' width='100%' src={SharkIcon} alt='' />
							</div>
						) : (
							''
						)}
					</div>
				)}
			</Card>
			<Card
				style={{
					...styles.selectors,
					width: '30%',
					padding: '15px 0px',
				}}
			>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
					}}
				>
					<div style={styles.selectorsFlex}>
						From
						<TextField
							name='from'
							// autoFocus
							style={styles.inputItem}
							value={state.from}
							type='number'
							InputProps={{
								style: {
									textAlign: 'center',
									fontSize: appReducer.isMobile ? 16 : 14,
								},
								startAdornment: (
									<InputAdornment position='start'>$</InputAdornment>
								),
							}}
							onChange={(event) => targetFromChange(event, event.target.value)}
						/>
					</div>
					<div style={styles.selectorsFlex}>
						To
						<TextField
							name='to'
							// autoFocus
							style={styles.inputItem}
							value={state.to}
							type='number'
							InputProps={{
								style: {
									textAlign: 'center',
									fontSize: appReducer.isMobile ? 16 : 14,
								},
								startAdornment: (
									<InputAdornment position='start'>$</InputAdornment>
								),
							}}
							onChange={(event) => targetToChange(event, event.target.value)}
						/>
					</div>
				</div>
				<div
					style={{
						display: 'flex',
						flexDirection: 'row',
						alignItems: 'center',
					}}
				>
					<div style={{ width: '50px' }}>Top</div>
					<FormControl component='fieldset'>
						<RadioGroup
							defaultValue='female'
							aria-label='gender'
							name='customized-radios'
							onChange={(event) => handlePercent(event, event.target.value)}
							value={state.percent}
							row
						>
							<FormControlLabel
								value='1'
								control={<Radio color='primary' />}
								label='1 %'
							/>
							<FormControlLabel
								value='5'
								control={<Radio color='primary' />}
								label='5 %'
							/>
							<FormControlLabel
								value='10'
								control={<Radio color='primary' />}
								label='10 %'
							/>
						</RadioGroup>
					</FormControl>
				</div>
			</Card>
			<Card style={styles.selectors}>
				<div style={{ fontSize: '13px' }}>
					Enter a Low to High $ range that you want to leave unshaded. For
					example, $70 to $90. Then choose a percentile to highlight those
					results within the unshaded area. To see an aggregated chart of Calls
					and Puts, Click 1 or more Expiration Dates and then click the Chart
					button.
				</div>
			</Card>
		</div>
	);
};
export default TopBarWebView;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/webViewComponents/topBar.jsx